import axios from 'axios'
import { getItem } from '@/helpers/persistanceStorage'
import mixins from "@/helpers/mixins";
import {config} from "@fullcalendar/core";

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

api.interceptors.request.use(
  config => {
    if (!config.url?.startsWith('/mainPublic/')) {
      mixins().checkJwtExp()
    }
    const token = getItem('user')
    if (token) {
      const jwtToken = token ? `Bearer ${token.jwtToken}` : ''
      config.headers.Authorization = jwtToken
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
//
// api.interceptors.response.use(
//     config => {
//         return config
//     },
//     error => {
//         mixins().checkResponseError(error)
//         return Promise.reject(error)
//     }
// )

export default api
